// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DEqB","col":"styles_col__26wcY"};